import React, { FC, useCallback } from "react";
import { Button, OnboardingContent, FireworksBackground } from "@xapp/components";

import { ClientApp } from "models/App";

export interface CompletionStepProps {
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;

    aside?: React.ReactNode;

    app?: ClientApp;
    /**
     * Callback when user clicks continue to dashboard
     */
    onNext?: () => void;
}

export const CompletionStep: FC<CompletionStepProps> = (props) => {
    const { onNext } = props;

    const handleContinue = useCallback(() => {
        onNext?.();
    }, [onNext]);

    return (
        <OnboardingContent>
            <FireworksBackground style={{ height: "100%" }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "40px 20px",
                        textAlign: "center",
                    }}
                >
                    <div style={{ width: "100%", maxWidth: "600px" }}>
                        <div style={{ marginBottom: "30px" }}>
                            <h1 style={{ fontSize: "2.5rem", marginBottom: "20px", color: "#1aa7dc" }}>
                                🎉 You're All Done!
                            </h1>
                            <p style={{ fontSize: "1.2rem", lineHeight: "1.6", marginBottom: "30px" }}>
                                Congratulations! Your AI-powered booking system is now configured and ready to capture
                                leads.
                            </p>
                        </div>

                        <div
                            style={{
                                backgroundColor: "rgba(255, 255, 255, 0.95)",
                                borderRadius: "12px",
                                padding: "30px",
                                marginBottom: "30px",
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <h3 style={{ fontSize: "1.3rem", marginBottom: "20px", color: "#333" }}>What's Next?</h3>

                            <div style={{ textAlign: "left", marginBottom: "25px" }}>
                                <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "15px" }}>
                                    <span
                                        style={{
                                            color: "#1aa7dc",
                                            fontSize: "1.2rem",
                                            marginRight: "10px",
                                            marginTop: "2px",
                                        }}
                                    >
                                        📅
                                    </span>
                                    <p style={{ margin: 0, lineHeight: "1.5" }}>
                                        <strong>Google Book Online Button:</strong> We're working on getting your "Book
                                        Online" button live on Google within the next 48 hours.
                                    </p>
                                </div>

                                <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "15px" }}>
                                    <span
                                        style={{
                                            color: "#1aa7dc",
                                            fontSize: "1.2rem",
                                            marginRight: "10px",
                                            marginTop: "2px",
                                        }}
                                    >
                                        📧
                                    </span>
                                    <p style={{ margin: 0, lineHeight: "1.5" }}>
                                        <strong>We'll Keep You Posted:</strong> You'll receive an email notification as
                                        soon as your booking system goes live.
                                    </p>
                                </div>

                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                    <span
                                        style={{
                                            color: "#1aa7dc",
                                            fontSize: "1.2rem",
                                            marginRight: "10px",
                                            marginTop: "2px",
                                        }}
                                    >
                                        ⚙️
                                    </span>
                                    <p style={{ margin: 0, lineHeight: "1.5" }}>
                                        <strong>Edit Anytime:</strong> You can modify all the settings you just
                                        configured from your dashboard.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <Button
                            id="goToDashboard"
                            label="Go to Dashboard"
                            variation="primary"
                            style={{
                                fontSize: "1.1rem",
                                padding: "12px 30px",
                                backgroundColor: "#1aa7dc",
                                borderColor: "#1aa7dc",
                            }}
                            onClick={handleContinue}
                        />
                    </div>
                </div>
            </FireworksBackground>
        </OnboardingContent>
    );
};
